import { Button, Form, Input, message, Modal, Space, Typography } from 'antd';
import axios from 'axios';
import React, { useState } from 'react';
import { useSWRConfig } from 'swr';

import { asyncErrorHandler } from '@/utils/asyncErrorHandler';

import { bookingListAPIUrl } from '../ReservationList/constants';
import { fetchBookingList } from '../ReservationList/helper';
import sharedStyles from '../sharedStyles.module.scss';
import type {
  PushNotificationFormValues,
  PushNotificationProps,
} from './types';

const { Item, useForm } = Form;
const { Text } = Typography;
const { TextArea } = Input;

const PushNotification = ({
  userId,
  cleanBookingsId,
  bookingListType,
}: PushNotificationProps) => {
  const { mutate } = useSWRConfig();
  const [form] = useForm<PushNotificationFormValues>();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const pushNotification = async (formValues: PushNotificationFormValues) => {
    const data = {
      ...formValues,
      userId,
      cleanBookingsId,
      type: 'clean',
    };

    try {
      await axios({
        method: 'POST',
        url: '/ezcon/api/notifyCleanBooking',
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
        data,
      });
      setIsOpenModal(false);
      mutate(
        bookingListAPIUrl,
        fetchBookingList(bookingListAPIUrl, bookingListType)
      );
      message.success('推播通知成功!');
    } catch (error) {
      const errObj = error.response.data;
      if (error.message.includes('502') && errObj.displayMessage) {
        message.error(errObj.displayMessage, 5);
      } else {
        asyncErrorHandler(errObj, '推播通知失敗!');
      }
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setIsOpenModal(true)}>
        推播通知
      </Button>
      <Modal
        open={isOpenModal}
        centered
        destroyOnClose
        footer={null}
        onCancel={() => setIsOpenModal(false)}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            title: '清潔預約提醒',
            content: '提醒您10分鐘後會有清潔員抵達',
          }}
          onFinish={pushNotification}
        >
          <Item
            label={<Text type="secondary">標題</Text>}
            name="title"
            rules={[{ required: true, message: '請輸入標題' }]}
          >
            <Input placeholder="請輸入標題" />
          </Item>
          <Item
            label={<Text type="secondary">內容</Text>}
            name="content"
            rules={[{ required: true, message: '請輸入內容' }]}
          >
            <TextArea placeholder="請輸入內容" maxLength={100} rows={4} />
          </Item>
          <Item>
            <Space className={sharedStyles.footerButtonsContainer}>
              <Button onClick={() => setIsOpenModal(false)}>取消</Button>
              <Button type="primary" htmlType="submit">
                確定
              </Button>
            </Space>
          </Item>
        </Form>
      </Modal>
    </>
  );
};

export default PushNotification;
